import React, { useState, useRef, useEffect } from "react";
import { FaAngleDown } from "@react-icons/all-files/fa/FaAngleDown";

function renderTableOfContentsNode(toc) {
  return (
    <ul>
      {toc.items?.map((item) => (
        <li key={item.url} className="list-none">
          <p className="block py-1">
            <a href={item.url}>{item.title}</a>
          </p>
          {renderTableOfContentsNode(item)}
        </li>
      ))}
    </ul>
  );
}

export default function TableOfContents({ tableOfContents }) {
  const [tocOpen, setTocOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const ref = useRef();

  const updateHeight = () => {
    if (!ref.current) return;
    setHeight(ref.current.scrollHeight);
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);
  }, []);

  return (
    <div className="border-2 border-primary p-2">
      <button
        id="toc-toggle"
        className="w-full flex flex-row text-primary"
        onClick={() => setTocOpen(!tocOpen)}
      >
        <h3 className="text-left flex-grow">Table of Contents</h3>
        <FaAngleDown
          className={`text-3xl transform transition duration-500 ease-in-out ${
            tocOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        ref={ref}
        className={`overflow-hidden mt-0 transition-[height] duration-500 ease-in-out`}
        style={{ height: tocOpen ? height : 0 }}
      >
        <div className="mt-4" />
        {renderTableOfContentsNode(tableOfContents)}
      </div>
    </div>
  );
}
